module.exports = __webpack_public_path__ + "static/feature-0da421b0f0c3fe144d69e1770872f835.jpg";